import script from "./ApplicationInfoLOC.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationInfoLOC.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationInfoLOC.vue?vue&type=style&index=0&id=804e4e96&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-804e4e96"]])

export default __exports__